import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import Confetti from 'react-confetti';
import { playSfx, type SfxName } from '../utils/sfx';

interface CelebrationConfettiProps {
  /** Pieces in the burst: ~60 for a small "step done", 200+ for a big finish. */
  pieces?: number;
  /** Sound played once when the burst starts (null: silent). */
  sound?: SfxName | null;
  gravity?: number;
}

const prefersReducedMotion = () =>
  typeof window !== 'undefined' && !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

/**
 * One confetti burst over everything (taps pass through). Mount it when the
 * moment happens; it does not loop. Remount (change `key`) for another burst.
 */
export default function CelebrationConfetti({ pieces = 200, sound = 'confetti', gravity = 0.3 }: CelebrationConfettiProps) {
  useEffect(() => {
    if (sound) playSfx(sound);
  }, [sound]);
  if (prefersReducedMotion()) return null;
  return createPortal(
    <div className="pointer-events-none fixed inset-0 z-[10003]">
      <Confetti width={window.innerWidth} height={window.innerHeight} recycle={false} numberOfPieces={pieces} gravity={gravity} />
    </div>,
    document.body,
  );
}
